import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, DefaultLogin } from "./layouts";


// Route Views
import BlogOverview from "./views/BlogOverview";
import UserProfileLite from "./views/UserProfileLite";
import AddNewPost from "./views/AddNewPost";
import Errors from "./views/Errors";
import ComponentsOverview from "./views/ComponentsOverview";
import Tables from "./views/Tables";
import BlogPosts from "./views/BlogPosts";
import UsersList from "./views/UsersList";
import DevicesList from "./views/DevicesList";
import UserMessages from "./views/UserMessages";
import Login from "./views/Pages/Login";
import Register from "./views/Pages/Register";
import Logout from "./views/Logout";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/login" />
  },
  {
    path: "/users-list",
    layout: DefaultLayout,
    component: UsersList
  },
  {
    path: "/devices-list",
    layout: DefaultLayout,
    component: DevicesList
  },
  {
    path: "/login",
    layout: DefaultLogin,
    component: Login
  },  
  {
    path: "/register",
    layout: DefaultLogin,
    component: Register
  },  
  {
    path: "/user-messages",
    layout: DefaultLayout,
    component: () => <UserMessages />
  },
  {
    path: "/logout",
    layout: DefaultLogin,
    component: Logout
  }, 
  {
    path: "/blog-overview",
    layout: DefaultLayout,
    component: BlogOverview
  },
  {
    path: "/user-profile-lite",
    layout: DefaultLayout,
    component: UserProfileLite
  },
  {
    path: "/add-new-post",
    layout: DefaultLayout,
    component: AddNewPost
  },
  {
    path: "/errors",
    layout: DefaultLayout,
    component: Errors
  },
  {
    path: "/components-overview",
    layout: DefaultLayout,
    component: ComponentsOverview
  },
  {
    path: "/tables",
    layout: DefaultLayout,
    component: Tables
  },
  {
    path: "/blog-posts",
    layout: DefaultLayout,
    component: BlogPosts
  }
  
];
